// TODO: type properly

export let SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection["Ascending"] = "Ascending";
  SortDirection["Descending"] = "Descending";
  SortDirection["None"] = "None";
  return SortDirection;
}({});

// collection.field.active

// collection.field.active

/** The editorial-workflow `pages` slice: one flat record, unlike `PagesObject`. */

// eslint-disable-next-line @typescript-eslint/no-explicit-any